exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".back-link-holder,.invisible-back-link-holder{float:left;width:100%;margin-bottom:10px;cursor:pointer}.invisible-back-link-holder{visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/BackLink/index.scss
// module id = 1009
// module chunks = 0